import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { v4 as uuid } from 'uuid';
import { ReportTableDynamictableData } from '../DashboardContainer/DynamictableCondition';

function ReportsDataTable() {
  const { dashboardStore, activityStore, commonStore } = useStore();

  const [pageNumber, setPageNumber] = useState<number>(0);
  const [filterTwoData, setFilterTwoData] = useState<any[]>([]);
  const [name, setName] = useState<string>(
    dashboardStore.dashboard.valueForL3Orders?.replaceAll(' ', ''),
  );

  //  const [showText, setShow] = useState(false);
  useEffect(() => {
    const ids: any = ReportTableDynamictableData.filter(
      (element: any) => name === element.name,
    );
    setFilterTwoData(ids);
  }, [name]);

  useEffect(() => {
    setName(dashboardStore.dashboard.valueForL3Orders?.replaceAll(' ', ''));
    activityStore.OrdersReportsFetchTableDetails(
      '',
      1,
      dashboardStore.dashboard.valueForL3Orders?.replaceAll(' ', ''),
    );
    setPageNumber(1);
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.valueForL3Orders]);

  const caseHandler = () => {
    let tableDetails: any[] = [];
    switch (name) {
      case 'Received':
        tableDetails = activityStore.OrdersReports.received.data;
        break;
      case 'WaitingforApproval':
        tableDetails = activityStore.OrdersReports.waitingforApproval.data;
        break;
      case 'Approved':
        tableDetails = activityStore.OrdersReports.approved.data;
        break;
      case 'InProgress':
        tableDetails = activityStore.OrdersReports.inProgress.data;
        break;
      case 'Ready':
        tableDetails = activityStore.OrdersReports.ready.data;
        break;
      case 'Delivered':
        tableDetails = activityStore.OrdersReports.delivered.data;
        break;
      case 'Returned':
        tableDetails = activityStore.OrdersReports.returned.data;
        break;
      default:
        tableDetails = [];
    }
    return tableDetails;
  };

  const paginateFunction = (e: number) => {
    let searchValues = dashboardStore.dashboard.searchfilterparams;
    if (
      !_.isEmpty(searchValues) &&
      Object.values(searchValues).every((o) => o !== '') &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.OrdersReportsFetchTableDetails(searchValues, e, name);
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.OrdersReportsFetchSortTableDetails(
        dashboardStore.dashboard.orderData,
        name,
        dashboardStore.dashboard.orderName || '',
        e || 1,
        (activityStore.OrdersReports as any)[`${_.camelCase(name)}`].count || 0,
      );
    } else {
      activityStore.OrdersReportsFetchTableDetails(searchValues, e, name);
    }
    setPageNumber(e);
  };

  return (
    <>
      {commonStore.filterModeTwo.includes(filterTwoData[0]?.id) ? (
        <></>
      ) : (
        !!name?.length && (
          <DynamicTableComponent
            key={uuid()}
            data={caseHandler()}
            name={name}
            actiontype={''}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            setPageNumber={setPageNumber}
            searchFuncData={() => {}}
            isdisabled={commonStore.filterModeZero.includes(
              filterTwoData?.[0]?.id,
            )}
          />
        )
      )}
    </>
  );
}

export default observer(ReportsDataTable);
